import { useEffect } from 'react';
import { isTerminal, pendingStageFor, useTemplateRunStore } from '@/stores/use-template-run-store';
import { getTemplateRun } from './api';

const POLL_INTERVAL_MS = 3000;

const inFlight = new Set<string>();

async function pollRun(runId: string, templateId: string) {
  if (inFlight.has(runId)) return;
  inFlight.add(runId);
  let snapshot;
  try {
    snapshot = await getTemplateRun(templateId, runId);
  } catch {
    return;
  } finally {
    inFlight.delete(runId);
  }
  const { runs, matchSurface, setStage } = useTemplateRunStore.getState();
  const run = runs[runId];
  if (!run || isTerminal(run.stage)) return;
  if (snapshot.surfaceId && !run.surfaceId) matchSurface(runId, snapshot.surfaceId);
  setStage(runId, pendingStageFor(snapshot.stage));
}

export function useTemplateRunPolling(): void {
  const hasActiveRuns = useTemplateRunStore((s) =>
    Object.values(s.runs).some((run) => !isTerminal(run.stage)),
  );

  useEffect(() => {
    if (!hasActiveRuns) return;
    const timer = setInterval(() => {
      for (const run of Object.values(useTemplateRunStore.getState().runs)) {
        if (!isTerminal(run.stage)) void pollRun(run.runId, run.templateId);
      }
    }, POLL_INTERVAL_MS);
    return () => clearInterval(timer);
  }, [hasActiveRuns]);
}
